import IButton from '@inkline/inkline/src/components/IButton';
import ICheckbox from '@inkline/inkline/src/components/ICheckbox';

export default {
    name: 'ICheckboxButton',
    components: {
        IButton
    },
    extends: ICheckbox
};
